import React, { useState, useEffect } from "react";
import axios from "axios";

export default function EkycDetails({ uidOrRc }) {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [heading, setheading] = useState("");

  //  FIX: call API ONLY once when component loads (after submit)
  useEffect(() => {
    if (!uidOrRc || uidOrRc.trim() === "") return;

    searchData(uidOrRc);
  }, []);  

  const searchData = async (uid) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/api/ekyc`,
        {
          uidOrRc: uid,
        },
        {
          headers: {
            "X-React-Route": window.location.href,
          },
        }
      );

      const fetchedData = res.data?.data || [];

      const updatedData = fetchedData.map((item) => ({
        ...item,
        ben_reason_id: "",
        submitted: false,
      }));

      setheading(res.data?.heading);
      setData(updatedData);
      setMessage(fetchedData.length === 0 ? `No details found for ${uid}` : "");
      setAlertMsg("");
    } catch (err) {
      console.error(err);
      setMessage("Error fetching data");
    }
  };

  const handleReasonChange = (memberId, value) => {
    setData((prevData) =>
      prevData.map((row) =>
        row.memberId === memberId
          ? { ...row, ben_reason_id: value }
          : row
      )
    );
  };

  const handleRemove = async (row) => {
    if (!row.ben_reason_id) {
      window.alert("Please select a reason before proceeding.");
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/api/ekycinsert`,
        {
          memberId: row.memberId,
          rc_id: row.rc_id,
          slno: row.slno,
          ben_reason_id: row.ben_reason_id,
        },
        {
          headers: {
            "X-React-Route": window.location.href,
          },
        }
      );

      const msg = res.data.message;
      setAlertMsg(msg);

      setData((prevData) =>
        prevData.map((r) =>
          r.memberId === row.memberId
            ? { ...r, submitted: true }
            : r
        )
      );
    } catch (err) {
      console.error(err);
      setAlertMsg("Error submitting eKYC");
    }
  };

  return (
    <div className="p-4">
      {data.length > 0 && (
        <table align="center" width="75%" border="1" cellPadding="5" cellSpacing="0">
          <thead style={{ position: "sticky", top: 0 }}>
            <tr className="tableheader">
              <th colSpan={19}>{heading}</th>
            </tr>
            <tr className="tableheader">
              <td>Member Id</td>
              <td>Member Name</td>
              <td>UID</td>
              <td>eKYC<br />Status</td>
              <td>Reason</td>
              <td>Action</td>
            </tr>
          </thead>

          <tbody>
            {data.map((row) => (
              <tr key={row.memberId}
                style={{
                  backgroundColor: row.submitted ? "#d1fae5" : "transparent",
                  transition: "background-color 0.3s ease"
                }}
              >
                <td>{row.memberId}</td>
                <td>{row.member_name_en}</td>
                <td>{`XXXX-XXXX-${row.uid}`}</td>
                <td>{row.ekyc_status}</td>

                <td>
                  {row.reasondto?.length > 0 ? (
                    <select
                      value={row.ben_reason_id}
                      onChange={(e) => handleReasonChange(row.memberId, e.target.value)}
                      disabled={row.submitted}
                    >
                      <option value="">Select reason</option>
                      {row.reasondto.map((reason) => (
                        <option key={reason.ben_reason_id} value={reason.ben_reason_id}>
                          {reason.ben_reason_value}
                        </option>
                      ))}
                    </select>
                  ) : (
                    "---"
                  )}
                </td>

                <td>
                    {row.reasondto?.length > 0 && row.member_age <= 5 ? (

                    <button
                      onClick={() => !row.submitted && handleRemove(row)}
                      disabled={row.submitted}
                      style={{
                        background: row.submitted ? "#10b981" : "none",
                        border: row.submitted ? "1px solid #059669" : "none",
                        color: row.submitted ? "white" : "#dc2626",
                        padding: row.submitted ? "4px 12px" : "0",
                        borderRadius: row.submitted ? "4px" : "0",
                        fontWeight: "600",
                        cursor: row.submitted ? "default" : "pointer",
                        transition: "all 0.3s ease"
                      }}
                    >
                      {row.submitted ? "Done" : "Submit"}
                    </button>
                  ) : (
                    "---"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div>
        <br />
        {message && <div className="mainhead" align="center">{message}</div>}
        {alertMsg && (
          <div className="mainhead" align="center">
            {alertMsg}
          </div>
        )}
      </div>
    </div>
  );
}